function shouldTerminateMegaMenu(pageDescriptor) {
  if (!pageDescriptor.hasChildren) {
    return true;
  }
  if (pageDescriptor.type === "Course") {
    return true;
  }
  return pageDescriptor.megaMenu.terminateMegaMenu;
}

export { shouldTerminateMegaMenu };
//# sourceMappingURL=descriptor.should-terminate-megamenu.js.map
